import React, { useEffect } from "react";
import Swiper from "swiper/bundle";
import "swiper/css/bundle";
import { Link } from "react-router-dom";

const HomePage = () => {
  useEffect(() => {
    const swiper = new Swiper(".h7-testimonial-slider", {
      slidesPerView: 1,
      centeredSlides: true,
      spaceBetween: 15,
      loop: true,
      autoplay: {
        delay: 4500,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".h5-story-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".h5-story-next",
        prevEl: ".h5-story-prev",
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 1,
          spaceBetween: 50,
        },
      },
    });

    return () => swiper.destroy(true, true); // cleanup
  }, []);

  useEffect(() => {
    const swiper = new Swiper(".h3-partner_slider", {
      slidesPerView: 2,
      spaceBetween: 15,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: { slidesPerView: 3, spaceBetween: 30 },
        992: { slidesPerView: 5, spaceBetween: 30 },
      },
    });

    return () => swiper.destroy(true, true);
  }, []);

  return (
    <>

      {/*===== HERO AREA STARTS =======*/}
      <div className="hero7-section-area max-md:pt-[80px]">
        <div className="container">
          <div className="row">
            <div className="col-lg-7">
              <div className="hero7-header-area">
                <div className="heading-content lg:h-[680px] md:p-[48px] px-[20px] py-[40px]">
                  <h5 className="text-anime-style-3 !text-[22px]">Healthy Kal, KFutureHealth ke Saath</h5>
                  <div className="space20" />
                  <h1 className="text-anime-style-3">
                    Your Family’s OPD & Wellness Partner
                  </h1>
                  <p className="text-[18px] my-[30px]">At KFutureHealth, we believe good health begins with the right care at the right time. As your trusted OPD & wellness partner, we bring affordable doctor consultations, preventive checkups, and holistic wellness plans under one roof.</p>
                  <p className="text-[18px] my-[30px]">From routine OPD visits to personalized wellness programs, we ensure that every member of your family stays healthy, stress-free, and future-ready. With a wide network of doctors and wellness experts, we make quality healthcare simple, accessible, and reliable.</p>
                  <div className="space32" />
                  <div className="btn-area1">
                    <a href="/plans" className="vl-btn6 max-md:w-full max-md:px-[20px]">
                      Discover Your Wellness Plan
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="images-area">
                {/* <img src="assets/img/all-images/hero/header__img.png" alt="" /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*===== HERO AREA ENDS =======*/}

      {/*===== MARQUEE AREA starts =======*/}
      <div className="slider6-section-area">
        <div className="marquee-wrap">
          <div className="marquee-text flex items-center gap-[30px]">
            <div className="brand-single-box">
              <h3>
                <img src="assets/img/elements/elements1.png" alt="" />{" "}
                Zero waiting period on OPD claims
              </h3>
            </div>
            <div className="brand-single-box">
              <h3>
                <img src="assets/img/elements/elements1.png" alt="" />{" "}
                Consultations
              </h3>
            </div>
            <div className="brand-single-box">
              <h3>
                <img src="assets/img/elements/elements1.png" alt="" />{" "}
                Pharmacy discounts up to 20%
              </h3>
            </div>
            <div className="brand-single-box">
              <h3>
                <img src="assets/img/elements/elements1.png" alt="" />{" "}
                Patient-Centered Approach
              </h3>
            </div>
            <div className="brand-single-box">
              <h3>
                <img src="assets/img/elements/elements1.png" alt="" />{" "}
                Trusted doctor network across India
              </h3>
            </div>
            <div className="brand-single-box">
              <h3>
                <img src="assets/img/elements/elements1.png" alt="" />{" "}
                Diagnostics & Radiology
              </h3>
            </div>
          </div>
        </div>
      </div>
      {/*===== MARQUEE AREA ENDS =======*/}

      {/*===== ABOUT AREA STARTS =======*/}
      <div className="about6-section-area sp1">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="img1 image-anime">
                <img src="assets/img/all-images/about/about-img12.png" alt="" />
              </div>
            </div>
            <div className="col-lg-3">
              <div className="img2 image-anime">
                <img src="assets/img/all-images/about/about-img13.png" alt="" />
              </div>
            </div>
            <div className="col-lg-5">
              <div className="heading7">
                <div className="heading">
                  <h5>About Us</h5>
                  <div className="space20" />
                  <h2 className="text-anime-style-3">
                    Start your journey towards better health today
                  </h2>
                </div>
                <div className="space40" />
                <p>
                  KFutureHealth is a modern healthcare brand dedicated to making OPD services and wellness plans affordable and accessible for every Indian family. Our mission is simple – to prevent major health issues by focusing on early detection, regular checkups, and a healthy lifestyle.
                </p>
                <p className="mt-4">
                  With a wide network of doctors, diagnostic centers, and wellness experts, we are committed to bringing quality healthcare closer to you – at prices you can trust.
                </p>
                <div className="space32" />
                <div className="btn-area1">
                  <Link to="/plans" className="vl-btn6">
                    Get Started Now
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*===== ABOUT AREA ENDS =======*/}


       {/*===== SERVICE AREA STARTS =======*/}
      <div
        className="service7-section-area sp8"
        style={{
          backgroundImage: "url(assets/img/all-images/bg/bg8.png)",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-5">
              <div className="heading7">
                <h5>सेवाएँ</h5>
                <div className="space20" />
                <h2 className="text-anime-style-3">
                  जीवन के हर पड़ाव पर बेहतरीन सेवाएँ
                </h2>
              </div>
            </div>
            <div className="col-lg-2" />
            <div className="col-lg-5">
              <div className="heading7">
                <div className="space20 d-lg-none d-block" />
                <p>
                  हम एक परिवार हैं, जो OPD और वेलनेस प्लान के लिए बेहतरीन देखभाल देने के लिए समर्पित है।
                </p>
              </div>
            </div>
          </div>
          <div className="space60" />
          <div className="row">
            <div className="col-lg-3 col-md-6">
              <div className="service-hidden-boxarea">
                <div className="service-boxarea">
                  <div className="icons">
                    <img src="assets/img/icons/consult.svg" width="28" alt="" />
                  </div>
                  <div className="space24" />
                  <div className="title">डॉक्टर कंसल्टेशन</div>
                  <div className="space16" />
                  <div className="text">
                    <div className="space20" />
                    <p>
                      कभी भी, ऑनलाइन या क्लिनिक में, योग्य डॉक्टरों से जुड़ें और बिना लंबी कतार या देरी के विशेषज्ञ सलाह और इलाज पाएं।
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="service-hidden-boxarea box2">
                <div className="service-boxarea">
                  <div className="icons">
                    <img
                      src="assets/img/icons/fullbody.svg"
                      width="28"
                      alt=""
                    />
                  </div>
                  <div className="space24" />
                  <div className="title">फुल बॉडी चेकअप</div>
                  <div className="space16" />
                  <div className="text">
                    <div className="space20" />
                    <p>
                     शुगर, कोलेस्ट्रॉल, लिवर, किडनी, थायरॉइड सहित 91 पैरामीटर की जांच — पूरी सेहत और मानसिक शांति के लिए।
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="service-hidden-boxarea">
                <div className="service-boxarea">
                  <div className="icons">
                    <img
                      src="assets/img/icons/pharmacy.svg"
                      width="28"
                      alt=""
                    />
                  </div>
                  <div className="space24" />
                  <div className="title">फार्मेसी डिस्काउंट</div>
                  <div className="space16" />
                  <div className="text">
                    <div className="space20" />
                    <p>
                     हमारी आसान दवा डिलीवरी सेवा से समय और पैसा बचाएँ — आपकी सेहत की ज़रूरतों के लिए 20% तक की छूट।
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="service-hidden-boxarea">
                <div className="service-boxarea">
                  <div className="icons">
                    <img src="assets/img/icons/credit.svg" width="28" alt="" />
                  </div>
                  <div className="space24" />
                  <div className="title">वॉलेट और क्रेडिट्स</div>
                  <div className="space16" />
                  <div className="text">
                    <div className="space20" />
                    <p>
                      क्रेडिट का उपयोग करें और कंसल्टेशन, टेस्ट व दवाओं के लिए कैशलेस भुगतान करें — तेज़ और आसान!
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*===== SERVICE AREA ENDS =======*/}

     {/*===== WORKS AREA STARTS =======*/}
      <div className="works7-section-area sp1">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="heading7">
                <h5>हमें क्यों चुनें</h5>
                <div className="space20" />
                <h2 className="text-anime-style-3">
                  सवाल हैं? आपकी सेहत का पूरा ध्यान हमारे पास है!
                </h2>
                <div className="space16" />
                <p>
                 हम जानते हैं कि हेल्थकेयर के विकल्प कभी-कभी उलझन भरे हो सकते हैं — इसलिए हम आपकी मदद के लिए यहाँ हैं। OPD बेनिफिट से लेकर वेलनेस चेकअप तक, हमारे प्लान कैसे काम करते हैं, इसमें क्या शामिल है और यह आपके परिवार की सेहत की कैसे रक्षा करते हैं — इन सबके बारे में आपको स्पष्ट और सरल जवाब मिलेंगे। अपने केयर जर्नी के हर कदम पर आत्मविश्वास महसूस करें!
                </p>
                <div className="space12" />
                <div className="accordion" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        एक OPD प्लान में क्या-क्या शामिल होता है?
                      </button>
                    </h2>
                    <div
                      id="collapseOne"
                      className="accordion-collapse collapse show"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <p>
                          OPD प्लान में डॉक्टर कंसल्टेशन, डायग्नोस्टिक टेस्ट और प्रिस्क्राइब की गई दवाएं शामिल होती हैं — साथ ही हॉस्पिटलाइजेशन कवरेज (यदि आपने हॉस्पिटल कवरेज प्लान लिया है) — ताकि आपकी रोज़मर्रा की मेडिकल ज़रूरतें पूरी हो सकें।
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        वेलनेस प्लान से क्या फायदे मिलते हैं?
                      </button>
                    </h2>
                    <div
                      id="collapseTwo"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <p>
                         वेलनेस प्लान में वार्षिक हेल्थ चेकअप, लाइफस्टाइल और न्यूट्रिशन गाइडेंस, मेंटल वेलनेस सपोर्ट और प्रिवेंटिव स्क्रीनिंग शामिल हैं, जो आपको स्वस्थ रखने में मदद करते हैं।
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        क्या मैं अपने परिवार को इन प्लानों में शामिल कर सकता हूँ?
                      </button>
                    </h2>
                    <div
                      id="collapseThree"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <p>
                         हाँ, एक किफायती प्लान में आप अपने जीवनसाथी, बच्चों और माता-पिता सहित 4 तक परिवार के सदस्यों को कवर कर सकते हैं।
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="space32" />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="works-images-area">
                <div className="img1 text-end image-anime lg:translate-x-[160px]">
                  <img
                    src="assets/img/all-images/works/work-img15.png"
                    alt=""
                  />
                </div>
                <div className="img2 text-start image-anime">
                  <img
                    src="assets/img/all-images/works/work-img16.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*===== WORKS AREA ENDS =======*/}
    </>
  );
};

export default HomePage;
